export default function ProtectingWhatMattersMost() {
  return <section data-section-id="230325" id="protecting-what-matters-most" className="relative min-h-[90vh] flex items-center overflow-hidden py-20 lg:py-32 bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.05)_0%,transparent_70%)] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col items-start text-left order-2 lg:order-1">
            <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
              <h1 className="font-default text-5xl sm:text-6xl lg:text-[80px] leading-[1.05] font-bold text-foreground uppercase tracking-tighter drop-shadow-sm">
                Protection as Unique as <span className="italic font-serif text-primary lowercase">Your Legacy.</span>
              </h1>
              
            </div>
            
            <p className="mt-6 text-lg sm:text-xl text-muted-foreground max-w-xl font-default font-light leading-relaxed">
              A sophisticated approach to life insurance. Secure your family's future with a bespoke plan designed for lasting peace of mind.
            </p>
            
            <div className="mt-10">
              <p className="text-xl font-medium text-primary tracking-wide">
                Fill out the application below to get your quote
              </p>
            </div>
            
            {}
            <div className="mt-16 flex items-center gap-4 text-sm text-muted-foreground/60 font-mono uppercase tracking-widest">
              <span className="w-8 h-[1px] bg-secondary/40"></span>
              <span>Concierge Assurance</span>
            </div>
          </div>

          {}
          <div className="relative w-full max-w-xl mx-auto lg:ml-auto flex justify-center items-center order-1 lg:order-2">
            {}
            
            {}
            <div className="relative z-10 w-full aspect-square flex items-center justify-center">
              <div className="relative rounded-lg w-full h-full flex items-center justify-center">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691035/img/serene_landscape_frosted_glass.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691035/img/serene_landscape_frosted_glass.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691035/img/serene_landscape_frosted_glass.png-wvc-sizes" alt="Serene landscape behind frosted glass" className="w-full h-auto object-contain drop-shadow-xl backdrop-blur-md !bg-[rgba(0,0,0,1)] !text-[rgba(251,250,249,1)] !opacity-[1] rounded-lg" loading="lazy" decoding="async" src="https://lifecoverusa.com/wp-content/uploads/2026/05/af7d405a-fd10-557b-8c0f-542d49cf17bf.jpg" src="https://lifecoverusa.com/wp-content/uploads/2026/05/How-Family-Visits-Impact-Older-Adults-Mental-Health-in-Assisted-Living-Communities-hero-1.jpg" />
              </div>
              
              {}
              <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-secondary/30 rounded-md" />
              <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-secondary/30 rounded-md !text-[rgba(251,250,249,1)]" />
              <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-secondary/30 rounded-md" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-secondary/30 rounded-md" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}